import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';

@Injectable()
export class ReportService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }
  summaryTimeProcessTicket(payload?: any) {
    return this.post(`/v2/report/summary-time-process-ticket`, payload);
  }

  summaryPersonal(payload?: any) {
    return this.post(`/v2/report/summary-personal`, payload);
  }

  summaryCampaignAgent(payload?: any) {
    return this.post(`/v2/campaigns/agent-reports`, payload);
  }

  summaryCampaignSummary(payload?: any) {
    return this.post(`/v2/campaigns/summary-reports`, payload);
  }

  summaryGroupv3(payload?: any) {
    return this.post('/v2/report/summary-groups', payload);
  }

  summaryv3(query?: any) {
    return this.get('/v3/report/summary', query);
  }

  ticketv2(query?: any) {
    return this.get('/v2/report/summary-ticket', query);
  }

  customerv2(query?: any) {
    return this.post('/v2/report/summary-customer', query);
  }

  agentv2(query?: any) {
    return this.post('/v2/report/summary-agent', query);
  }

  agentDetailv2(query?: any, payload?: any) {
    return this.post(`/v2/report/summary-agent/${query}`, payload);
  }

  summary(query?: any) {
    return this.get('/report/summary', query);
  }

  reportTicketSummary(query?: any) {
    return this.get('/report/ticket-summary', query);
  }

  reportContactSummary(query?: any) {
    return this.get('/report/contact-summary', query);
  }

  reportTicket(query?: any) {
    return this.get('/report/ticket', query);
  }

  reportService(query?: any) {
    return this.get('/report/ticket-service', query);
  }

  reportContact(query?: any) {
    return this.get('/report/contact', query);
  }

  quickSummary(query?: any) {
    return this.get('/quick-summary', query);
  }
  reportChannel(query?: any) {
    return this.postServer('/v2/report/sources', query);
  }
  reportAgent(query?: any) {
    return this.postServer('/v2/report/agents', query);
  }

  reportHistory(query?: any, body?: any) {
    // return this.postServer('/v2/report/call-history', query);
    const user = JSON.parse(localStorage.getItem('User'));
    let search = '?',
      i = 0;
    Object.keys(query).forEach(key => {
      search += `${key}=${query[key]}`;
      if (++i < Object.keys(query).length) {
        search += '&';
      }
    });
    return this.postFullUrl(environment.api_evs + '/omap/report/v1/' + user.tenant_id + '/call-history' + search, body);
  }
  exportHistory(query?: any, body?: any) {
    return this.getexcel('/v2/report/export/call-history', 'CallHistoryReport', 'POST', query, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Report.service.ts